import { CallbackGroup } from './eventSystem';

export class FetchAssistant {

    key = '';
    _requestMiddleware = [];

    /**
     * @param { string } key - The key/id for the class instance.
     * @param { function[] } middleware - An array of middleware functions to initialize with.
     */
    constructor( key, middleware = [] ) {
        this.key = key;
        this._requestMiddleware = new CallbackGroup();

        // Add middleware (if provided) to the callback group.
        for ( let i = 0; i < middleware.length; i++ ) {
            this.addMiddleware( middleware[ i ] );
        }
    }

    /**
     * Adds a middleware function. Any registered middleware functions will be
     * applied to the request.
     * 
     * @param { function } fn - The middleware function to add to the requests.
     */
    addMiddleware( fn ) {
        this._requestMiddleware.add( fn );
    }

    /**
     * Removes a middleware function. Any registered middleware functions will be
     * applied to the request.
     * 
     * @param { function } fn - The middleware function to add to the requests.
     */
    removeMiddleware( fn ) {
        this._requestMiddleware.remove( fn );
    }

    /**
     * Creates a GET request using the given options.
     * 
     * @param { object } options
     */
    async GET( { endpoint, headers, body, bearerToken = undefined } ) {
        return await this.fetch( { endpoint, method: 'GET', headers, body, bearerToken } );
    }

    /**
     * Creates a POST request using the given options.
     * 
     * @param { object } options
     */
    async POST( { endpoint, headers, body, bearerToken = undefined } ) {
        return await this.fetch( { endpoint, method: 'POST', headers, body, bearerToken } );
    }

    /**
     * Creates a request using the given options. Any registered middleware functions
     * will be applied to the request.
     * 
     * @param { object } options
     */
    async fetch( { endpoint, method = 'GET', headers, body, bearerToken = undefined } ) {
        const options = {
            method,
            headers: {
                ...headers,
                ...( bearerToken ? { 'Authorization': `Bearer ${ bearerToken }` } : {} ),
            },
            body,
        };

        this._requestMiddleware.invoke( endpoint, options );
        return await fetch( endpoint, { method: 'POST', ...options } );
    }

    /**
     * Creates a GET request using the given options.
     * 
     * @param { object } options
     */
    static async GET( { endpoint, headers, body, bearerToken = undefined } ) {
        return await FetchAssistant.fetch( { endpoint, method: 'GET', headers, body, bearerToken } );
    }

    /**
     * Creates a POST request using the given options.
     * 
     * @param { object } options
     */
    static async POST( { endpoint, headers, body, bearerToken = undefined } ) {
        return await FetchAssistant.fetch( { endpoint, method: 'POST', headers, body, bearerToken } );
    }

    /**
     * Creates a request using the given options.
     * 
     * @param { object } options
     */
    static async fetch( { endpoint, method = 'GET', headers, body, bearerToken = undefined } ) {
        const options = {
            method,
            headers: {
                ...headers,
                ...( bearerToken ? { 'Authorization': `Bearer ${ bearerToken }` } : {} ),
            },
            body,
        };
        return await fetch( endpoint, { method: 'POST', ...options } );
    }

}
